export const environment = {
  production: true,
  apiUrl: 'https://api.ftp.qa.theunit.dev/api/v1',
  otfEnvUrl:'https://otf.ftp.qa.theunit.dev/',
  awsRegion: 'eu-west-1',
  awsUserPoolId: 'eu-west-1_BrpsPdgJo',
  awsUserPoolClientId: '67luugn87ut866bu5e6n3g3m8i',
  awsCognitoDomain: 'cognito-idp.eu-west-1.amazonaws.com',
  strapiUrl: 'https://cms.ftp.dev.theunit.dev/api',
  strapiToken:
    '413e5602f93fb52c8cad330da2530019aec0b88ebaa9bbed462a5307954e9a0d4015c5fdcd807410c2fb4d67478ecea05f74b99fbb053c9ce678eb36144fe27188022fc659e6a9e8669f9f9aba38c666121a48b6b031ccd8d7e290ed5644c694c480fbe2b279ba03c429230646805865fefaa72f08ddd54b7edf83396ca68098',
};
